import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import LazyImage from "web/react/components/lazy-load-image/lazy-load-image";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import { useRothko } from "web/react/hooks/use-rothko/use-rothko";
import styles from "./ajax-related-search-product-images.module.css";

function AjaxRelatedSearchProductImages({ feedUrl, isRoundedImage, showFallBack }) {
    const ENDPOINT = "modules/related_search_products";

    const { data, isFetching, isFetched } = useRothko(ENDPOINT, { feed_url: feedUrl });

    const completeWithImages = isFetched && data?.products.length > 0;
    const completeNoImages = isFetched && data?.products.length === 0;

    return (
        <div className={styles.relatedSearchImages}>
            {completeNoImages && showFallBack && <span className={styles.fallback}>{"L"}</span>}
            {completeWithImages &&
                data?.products.map((product) => {
                    return (
                        <LazyImage
                            key={product.image_url}
                            src={product.image_url}
                            alt={product.alt_text}
                            className={clsx(styles.relatedSearchImage, {
                                [styles.relatedSearchImageRounded]: isRoundedImage,
                            })}
                            width={128}
                            height={160}
                        />
                    );
                })}
            {isFetching ? <LoadingSpinner /> : null}
        </div>
    );
}

AjaxRelatedSearchProductImages.defaultProps = {
    isRoundedImage: false,
    showFallBack: false,
};

AjaxRelatedSearchProductImages.propTypes = {
    feedUrl: PropTypes.string.isRequired,
    isRoundedImage: PropTypes.bool,
    showFallBack: PropTypes.bool,
};

export default AjaxRelatedSearchProductImages;
